module.exports = __webpack_public_path__ + "3e94997bbd47fc6db5098dd57d501572.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon.woff
// module id = 918
// module chunks = 0